module.exports = __webpack_public_path__ + "static/media/restart.5324e6ec.svg";